import type { ChallengeInfo } from "@expert/sales-tools";

import { AnnouncementEndQuizContent } from "./content/AnnouncementEndQuizContent";
import { AnnouncementEndSoloContent } from "./content/AnnouncementEndSoloContent";
import { AnnouncementEndTeamContent } from "./content/AnnouncementEndTeamContent";

export type AnnouncementEndContentProps = {
    challengeType: ChallengeInfo["challengeType"];
    contentProps: ContentProps;
};

export type ContentProps = {
    challenge: ChallengeInfo;
    onDismiss: () => void;
    empId: string;
};

export function AnnouncementEndContentFactory({ challengeType, contentProps }: AnnouncementEndContentProps) {
    switch (challengeType) {
        case "solo":
            return <AnnouncementEndSoloContent {...contentProps} />;
        case "team":
            return <AnnouncementEndTeamContent {...contentProps} />;
        case "quiz":
            return <AnnouncementEndQuizContent {...contentProps} />;
    }
}
